import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import { Button } from "@badi/badi-components";

import { translate } from "base/shared/Localization";
import { getHomePath } from "Sections/Home/routes";
import BadiLogo from "components/Icons/BadiLogo";
import { TopBarBase } from "components/Layout/TopBar";

const ListRoomApartmentTopBar = ({ onClick }) => (
  <TopBarBase>
    <Link to={getHomePath()}>
      <BadiLogo />
    </Link>
    <Button dataQa="landing-topbar-button" onClick={onClick}>
      {translate("rentRoom.button.text")}
    </Button>
  </TopBarBase>
);

ListRoomApartmentTopBar.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default ListRoomApartmentTopBar;
